function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var Svg1 = function Svg1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.472 117.469"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M24.887 0v-117.469H.452c-1.991 11.946-14.48 21.9-32.037 22.082v19.005h28.056V0z",
    "data-name": "Path 32190",
    style: {
      fill: "#fff3ed"
    },
    transform: "translate(31.585 117.469)"
  }));
};
export default Svg1;